import React, { createContext, useContext, useState } from 'react';

const StoreContext = createContext();

export function useGlobalData() {
  return useContext(StoreContext);
}

export function StoreProvider({ initialData, children }) {
  const [data, setData] = useState(initialData);

  function mergeData(newState) {
    setData({ ...data, ...newState });
  }

  return (
    <StoreContext.Provider value={{ globalData: data, setGlobalData: mergeData }}>
      {children}
    </StoreContext.Provider>
  );
}
